import { IStack } from './IStack';

export class Stack<T> implements IStack<T> {
  private storage: T[] = [];

  constructor(private capacity: number = Infinity) {
    // Empty
  }

  push(item: T): void {
    if (this.size() === this.capacity) {
    }
    this.storage.push(item);
    console.log("Stack" + this.storage);
  }

  pop(): T | undefined {
    return this.storage.pop();
  }

  peek(): T | undefined {
    return this.storage[this.size() - 1];
  }

  size(): number {
    return this.storage.length;
  }
}
